import React, { useState, useEffect } from "react";

import RequestHandler from "util/RequestHandler";

import PaymentSetTableFilter from "../Filters/PaymentSetTableFilter";
import PaymentSetAddForm from "../Forms/PaymentSetAddForm";
import PaymentSetUpdateForm from "../Forms/PaymentSetUpdateForm";

import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  Tooltip,
  Modal,
} from "antd";
import {
  BarsOutlined,
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

const PaymentSet = () => {
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
  });
  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});

  useEffect(() => getTableData(), [tableDataQueryOptions]);

  const getTableData = () => {
    const { skip, take, filter } = tableDataQueryOptions;

    setTableData({
      ...tableData,
      loading: true,
    });

    const query = filter ? `&$filter=${filter}` : "";
    RequestHandler.get(
      `/PaymentSet?$count=true${query}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response["@odata.count"],
        loading: false,
      });
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      skip: 0,
      current: 1,
      take: tableDataQueryOptions.take,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return { skip: 0, current: 1, take: prevState.take, filter: query };
    });
  };

  const handleOnClickUpdate = (record) => {
    RequestHandler.get(`/PaymentSet/GetById/${record.id}`).then((response) => {
      if (response) {
        setUpdateFormData(response);
        setUpdateFormVisibility(true);
      }
    });
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/PaymentSet/${id}`).then((response) => {
      if (response?.success) {
        getTableData();
      }
    });
  };

  const onAddSuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const onUpdateSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  // const renderIsInstallmentActive = (data) => data ? (
  //   <Tooltip title="Aktif">
  //     <CheckCircleOutlined
  //       style={{ color: "green", fontSize: "130%" }}
  //     />
  //   </Tooltip>
  // ) : (
  //   <Tooltip title="Pasif">
  //     <CloseCircleOutlined
  //       style={{ color: "red", fontSize: "130%" }}
  //     />
  //   </Tooltip>
  // );

  const renderIsInstallmentActive = (data) => {
    return `${data.length} banka`;
  };

  const columns = [
    {
      title: "Ödeme Seti Adı",
      dataIndex: "name",
    },
    {
      title: "Tek Çekim",
      dataIndex: "isInstallmentActive1",
      align: "center",
      render: renderIsInstallmentActive,
    },
    {
      title: "2 Taksit",
      dataIndex: "isInstallmentActive2",
      align: "center",
      render: renderIsInstallmentActive,
    },
    {
      title: "3 Taksit",
      dataIndex: "isInstallmentActive3",
      align: "center",
      render: renderIsInstallmentActive,
    },
    {
      title: "4 Taksit",
      dataIndex: "isInstallmentActive4",
      align: "center",
      render: renderIsInstallmentActive,
    },
    {
      title: "5 Taksit",
      dataIndex: "isInstallmentActive5",
      align: "center",
      render: renderIsInstallmentActive,
    },
    {
      title: "6 Taksit",
      dataIndex: "isInstallmentActive6",
      align: "center",
      render: renderIsInstallmentActive,
    },
    {
      title: "7 Taksit",
      dataIndex: "isInstallmentActive7",
      align: "center",
      render: renderIsInstallmentActive,
    },
    {
      title: "8 Taksit",
      dataIndex: "isInstallmentActive8",
      align: "center",
      render: renderIsInstallmentActive,
    },
    {
      title: "9 Taksit",
      dataIndex: "isInstallmentActive9",
      align: "center",
      render: renderIsInstallmentActive,
    },
    {
      title: "10 Taksit",
      dataIndex: "isInstallmentActive10",
      align: "center",
      render: renderIsInstallmentActive,
    },
    {
      title: "11 Taksit",
      dataIndex: "isInstallmentActive11",
      align: "center",
      render: renderIsInstallmentActive,
    },
    {
      title: "12 Taksit",
      dataIndex: "isInstallmentActive12",
      align: "center",
      render: renderIsInstallmentActive,
    },
    {
      title: "Düzenle",
      align: "center",
      render: (row) => (
        <a onClick={() => handleOnClickUpdate(row)}>
          <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
        </a>
      ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      align: "center",
      render: (data) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(data)}
        >
          <a>
            <DeleteOutlined style={{ color: "red", fontSize: "130%" }} />
          </a>
        </Popconfirm>
      ),
    },
  ];

  return (
    <>
      <Row align="middle">
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginBottom: 0 }}>
            <BarsOutlined /> ÖDEME SETLERİ
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => {
              setAddFormVisibility(true);
            }}
            style={{ marginBottom: 0 }}
          >
            <PlusOutlined /> Ödeme Seti Ekle
          </Button>
        </Col>
      </Row>

      <PaymentSetTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey="id"
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
          />
        </Col>
      </Row>

      <Modal
        id="addPaymentSetDrawer"
        title="Ödeme Seti Ekle"
        bodyStyle={{ padding: 24 }}
        width={1600}
        centered={true}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
        maxHeight={800}
        footer={null}
        onCancel={() => setAddFormVisibility(false)}
        destroyOnClose={true}
      >
        <PaymentSetAddForm onSuccess={onAddSuccess} />
      </Modal>

      <Modal
        id="updatePaymentSetDrawer"
        title="Ödeme Seti Güncelle"
        bodyStyle={{ padding: 24 }}
        width={1600}
        centered={true}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
        maxHeight={800}
        footer={null}
        onCancel={() => setUpdateFormVisibility(false)}
        destroyOnClose={true}
      >
        <PaymentSetUpdateForm
          data={updateFormData}
          onSuccess={onUpdateSuccess}
        />
      </Modal>
    </>
  );
};

export default PaymentSet;
